export const defaultTheme = {
  color: {
    background: "#f3f3f4",
    default: "#676a6c",
    primary: "#007bff",
    secondary: "#6c757d",
    success: "#28a745",
    danger: "#dc3545",
    warning: "#ffc107",
    info: "#17a2b8",
    light: "#f8f9fa",
    dark: "#343a40",
  },
  components: {
    Button: {
      css: `
            font-weight: 600;
            font-family: "Montserrat", sans-serif;
        `,
    },
    Page: {
      css: ``,
    },
    FloatInputContainer: {
      css: `
                &[type="date"] {
                    background: red !important;
                }
            `,
    },
    InputLabel: {
      css: `
                height: 34px;
                line-height: 34px;
                padding: 0px 4px;
            `,
    },
    PageTitle: {
      background: "#fff",
      title: {
        fontSize: "36px",
        fontWeight: "300",
        margin: "0px",
      },
      subtitle: {
        fontSize: "20px",
        fontWeight: "300",
        margin: "0px 0px 0px 6px",
      },
      css: "",
    },
    Card: {
      css: `
                border:1px solid rgba(0,0,0,0.1);
                border-radius: 3px;
                font-size: 14px;

                &.hover {
                    cursor: pointer;
                    transition: all 150ms;
                    user-select: none;

                    &:hover {
                        background: rgba(0,0,0,0.03);
                    }
                    
                    &:active {
                        background: rgba(0,0,0,0.075);
                    }
                }
            `,
    },
    CardHeader: {
      css: `
                border-top: none;
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
                font-weight: 800;
                color: #333;
            `,
    },
    CardBody: {
      css: `
                &.compact {
                    padding: 7px;
                }
            `,
    },
    CardFooter: {
      css: "",
    },
    Content: {
      padding: "15px",
    },
    h1: {
      fontSize: "2em",
      fontWeight: "300",
      css: "",
    },
    ModalTitle: {
      css: `
                > h1 {
                    color: #000;
                    user-select: none;
                    font-weight: bold;
                    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans", "Helvetica Neue",sans-serif;
                }
            `,
    },
    SmallValueBox: {
      css: `
                .smll-vl-bx-vl {
                    font-weight: bold;
                    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans", "Helvetica Neue",sans-serif;
                    font-size: 18px;
                }

                .smll-vl-bx-lbl {
                    font-size: 12px;
                }
            `,
    },
    Table: {
      css: `
                &.valign-top {
                    tbody tr td {
                        vertical-align: top;
                    }
                }

                &.valign-middle {
                    tbody tr td {
                        vertical-align: middle;
                    }
                }

                &.valign-bottom {
                    tbody tr td {
                        vertical-align: bottom;
                    }
            `,
    },
    DropdownMenuElement: {
      css: `
                font-size: 14px;
                line-height: 18px;

                a {
                    font-size: 14px;
                    line-height: 18px;
                }
            `,
    },
  },
  sizes: {
    spacing: "15px",
    fontSize: "14px",
    breakpoints: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
};
